import { useQuery } from '@tanstack/react-query';
import type { ExportableAttributes } from '@/features/agent/export_requests/types/ExportRequest';

interface UseFetchExportableAttributesOptions {
  enabled?: boolean;
}

export default function useFetchExportableAttributes(
  resource_type: string,
  options?: UseFetchExportableAttributesOptions
) {
  return useQuery({
    queryKey: ['exportable_attributes', resource_type],
    queryFn: async () => {
      const response = await fetch(
        `/agent/api/export_requests/${resource_type}/exportable_attributes`
      );
      const data: ExportableAttributes = await response.json();

      return data;
    },
    enabled: options?.enabled ?? (!!resource_type && resource_type !== ''), // optionsのenabledがあればそれを使用、なければデフォルト条件
  });
}
